import { Injectable } from '@angular/core';
import { FiAddressTypes } from '../../core/address-types';
import { AppTextService } from '../app-text';
import { FiContactInformationTypes } from '../types/fi-contact-information-types';
import { Subject } from 'rxjs';
import { FiAuthenticateSharedService, IUserContactUniqueData } from '../fi-auth-shared/fi-authenticate-shared.service';
import { IContactModel } from '@fi-shared/models/common';

const AddressTypes = FiAddressTypes;
const AddressTypesNamesMap = {};

AddressTypesNamesMap[AddressTypes.HomeAddress] = ['common.home_address', 'common.address'];
AddressTypesNamesMap[AddressTypes.WorkAddress] = ['common.work_address', 'common.work_address'];
AddressTypesNamesMap[AddressTypes.OtherAddress] = ['common.other_address', 'common.other_address'];
AddressTypesNamesMap[AddressTypes.ImportedAddress] = ['common.imported_address', 'common.imported_address'];

const ContactInformationTypes = FiContactInformationTypes;
const ContactInformationTypesNamesMap: { [prop: number]: string } = {};

ContactInformationTypesNamesMap[ContactInformationTypes.WorkEmailAddress] = 'common.work_email_address';
ContactInformationTypesNamesMap[ContactInformationTypes.PrivateEmailAddress] = 'common.private_email_address';
ContactInformationTypesNamesMap[ContactInformationTypes.OtherEmailAddress] = 'common.other_email_address';
//ContactInformationTypesNamesMap[ContactInformationTypes.ImportedEmailAddress] = 'common.imported_email_address';

ContactInformationTypesNamesMap[ContactInformationTypes.WorkPhoneNumber] = 'common.work_phone_number';
ContactInformationTypesNamesMap[ContactInformationTypes.CellPhoneNumber] = 'common.mobile_phone_number';
ContactInformationTypesNamesMap[ContactInformationTypes.HomePhoneNumber] = 'common.home_phone_number';
ContactInformationTypesNamesMap[ContactInformationTypes.OtherPhoneNumber] = 'common.other_phone_number';
//ContactInformationTypesNamesMap[ContactInformationTypes.ImportedPhoneNumber] = 'common.imported_phone_number';

const addressTypes: FiAddressTypes[] = [
    AddressTypes.HomeAddress,
    AddressTypes.WorkAddress,
    AddressTypes.OtherAddress,
    AddressTypes.ImportedAddress,
];

const phoneNumberTypes: FiContactInformationTypes[] = [
    ContactInformationTypes.WorkPhoneNumber,
    ContactInformationTypes.CellPhoneNumber,
    ContactInformationTypes.HomePhoneNumber,
    ContactInformationTypes.OtherPhoneNumber,
    //ContactInformationTypes.ImportedPhoneNumber,
];

const emailTypes: FiContactInformationTypes[] = [
    ContactInformationTypes.WorkEmailAddress,
    ContactInformationTypes.PrivateEmailAddress,
    ContactInformationTypes.OtherEmailAddress,
    //ContactInformationTypes.ImportedEmailAddress,
];

const phoneNumberTypesMap: { [prop: number]: string } = {};
phoneNumberTypesMap[ContactInformationTypes.WorkPhoneNumber] = 'common.work';
phoneNumberTypesMap[ContactInformationTypes.CellPhoneNumber] = 'common.mobile';
phoneNumberTypesMap[ContactInformationTypes.HomePhoneNumber] = 'common.home_phone_number';
phoneNumberTypesMap[ContactInformationTypes.OtherPhoneNumber] = 'common.other_phone_number';

@Injectable()
export class ContactService {
    constructor(
        private appTextService: AppTextService,
        private fiAuthenticateSharedService: FiAuthenticateSharedService,
    ) {}

    /*private _isContactUniqueCheckFinished$ = new Subject<void>();
    get isContactUniqueCheckFinished$() {
        return this._isContactUniqueCheckFinished$.asObservable();
    };*/
    isContactUnique(userId: number, contactValue: string): Promise<IUserContactUniqueData> {
        return new Promise<IUserContactUniqueData>((resolve, reject) => {
            this.fiAuthenticateSharedService.getContactUniqueData(userId, [contactValue]).then((result) => {
                resolve(result[0]);
                //this._isContactUniqueCheckFinished$.next();
            }, reject);
        });
    }

    getAddressTypeName(AddressTypesId: number, useSimpleName: boolean): string {
        let nameIndex = 'common.address';

        const namesArray = AddressTypesNamesMap[AddressTypesId];
        if (namesArray) nameIndex = namesArray[useSimpleName ? 1 : 0];

        return this.appTextService.get(nameIndex);
    }

    getContactTypeName(ContactInformationTypeId: FiContactInformationTypes): string {
        return this.appTextService.get(ContactInformationTypesNamesMap[ContactInformationTypeId]);
    }

    getAddressTypes(): FiAddressTypes[] {
        return addressTypes;
    }

    getEmailTypes(): FiContactInformationTypes[] {
        return emailTypes;
    }

    getPhoneNumberTypes(): FiContactInformationTypes[] {
        return phoneNumberTypes;
    }

    getPhoneTypeName(contactType: FiContactInformationTypes): string {
        return this.appTextService.get(phoneNumberTypesMap[contactType]);
    }

    isContactImported(contact: IContactModel): boolean {
        return contact.IsImported;
    }

    isAddressImported(addressType: FiAddressTypes) {
        return addressType === FiAddressTypes.ImportedAddress;
    }

    isEmailType(contactType: FiContactInformationTypes): boolean {
        return this.getEmailTypes().includes(contactType);
    }

    isPhoneNumberType(contactType: FiContactInformationTypes): boolean {
        return this.getPhoneNumberTypes().includes(contactType);
    }

    isSelectAsDefaultDisabled(contactsLength: number, contact: IContactModel): boolean {
        return (
            contact.IsDefault ||
            (contactsLength < 2 && !this.isPhoneNumberType(contact.ContactType) && !this.isContactImported(contact))
        );
    }
}
